<template>
    <div class="movie-box movie-vertical-scroll-bar page-fixed city-wrapper" v-if="hide">

    <!-- 定位城市 -->
    <dl>
        <dt class="movie-box one-letter">当前城市</dt>
        <dd class="movie-box hot-city-wrapper">
            <div class="page-inline-block page-text-center hot-city" @click="selectCity(locationCity)">{{locationCity}}</div>
        </dd>
    </dl>
    
    <!-- 热门城市 -->
    <dl>
        <dt class="movie-box one-letter">热门城市</dt>
        <dd class="movie-box hot-city-wrapper">
            <div class="page-inline-block page-text-center hot-city" v-for="(item, ind) in hotCity" :key="ind" @click="selectCity(item.name)">{{item.name}}</div>
        </dd>
    </dl>
    


    <!-- 城市列表 -->
    <ul>
        <li v-for="(item, key) in cityList" :key="key">
            <a class="movie-box one-letter" :id="item.firstchar" :name="item.firstchar">{{item.firstchar}}</a>
            <div class="movie-box one-city-wrapper">
                <div class="city" v-for="(val, ind) in item.cities" :key="ind" @click="selectCity(val.name)">{{val.name}}</div>
            </div>
        </li>
    </ul>


    <!-- 导航 -->
    <div class="page-fixed acea-row row-column-around row-middle row-around city-letter-nav">
        <a class="page-text-center letter" v-for="(city, index) in cityNav" :key="index" :href="`#${city}`">{{city}}</a>
    </div>
    </div>
</template>

<script>
// import { } from "@api/public";
export default {
    name:"MovieCity",
    props: {
        hide: {
            type: Boolean,
            default: false
        },
        locationCity: {
            type: String,
            default: ""
        }
    },
    data: function(){
            return{
                cityList: [
                    {
                        "firstchar": "A",
                        "cities": [
                            {"name": "安庆" },
                            {"name": "安康" },
                            {"name": "安阳" },
                            {"name": "安顺" },
                            {"name": "澳门" },
                            {"name": "阿克苏" },
                            {"name": "阿勒泰" },
                            {"name": "阿坝" },
                            {"name": "阿拉善" },
                            {"name": "阿拉尔" },
                            {"name": "阿里" },
                            {"name": "鞍山"  }
                        ]
                    }, {
                        "firstchar": "B",
                        "cities": [
                            {"name": "亳州" },
                            {"name": "保亭" },
                            {"name": "保定" },
                            {"name": "保山" },
                            {"name": "包头" },
                            {"name": "北京" },
                            {"name": "北屯" },
                            {"name": "北海" },
                            {"name": "博尔塔拉" },
                            {"name": "宝鸡" },
                            {"name": "巴中" },
                            {"name": "巴彦淖尔" },
                            {"name": "巴音郭楞" },
                            {"name": "本溪" },
                            {"name": "毕节" },
                            {"name": "滨州" },
                            {"name": "白城" },
                            {"name": "白山" },
                            {"name": "白沙" },
                            {"name": "白银" },
                            {"name": "百色" },
                            {"name": "蚌埠"  }
                        ]
                    }, {
                        "firstchar": "C",
                        "cities": [
                            {"name": "崇左" },
                            {"name": "常州" },
                            {"name": "常德" },
                            {"name": "成都" },
                            {"name": "承德" },
                            {"name": "昌吉" },
                            {"name": "昌江" },
                            {"name": "昌都" },
                            {"name": "朝阳" },
                            {"name": "楚雄" },
                            {"name": "池州" },
                            {"name": "沧州" },
                            {"name": "滁州" },
                            {"name": "潮州" },
                            {"name": "澄迈" },
                            {"name": "赤峰" },
                            {"name": "郴州" },
                            {"name": "重庆" },
                            {"name": "长春" },
                            {"name": "长沙" },
                            {"name": "长治" },
                            {"name": "长白山"},
                            {"name": "淳安"}
                        ]
                    }, {
                        "firstchar": "D",
                        "cities": [
                            {"name": "东方" },
                            {"name": "东莞" },
                            {"name": "东营" },
                            {"name": "东阳" },
                            {"name": "丹东" },
                            {"name": "丹江口"},
                            {"name": "儋州" },
                            {"name": "大兴安岭" },
                            {"name": "大同" },
                            {"name": "大庆" },
                            {"name": "大理" },
                            {"name": "大连" },
                            {"name": "定安" },
                            {"name": "定西" },
                            {"name": "德宏" },
                            {"name": "德州" },
                            {"name": "德阳" },
                            {"name": "德清" },
                            {"name": "敦煌" },
                            {"name": "稻城" },
                            {"name": "达州" },
                            {"name": "迪庆" },
                            {"name": "都江堰"  }
                        ]
                    }, {
                        "firstchar": "E",
                        "cities": [
                            {"name": "峨眉山" },
                            {"name": "恩施" },
                            {"name": "鄂尔多斯" },
                            {"name": "鄂州"  }
                        ]
                    }, {
                        "firstchar": "F",
                        "cities": [
                            {"name": "佛山" },
                            {"name": "凤凰" },
                            {"name": "抚州" },
                            {"name": "抚顺" },
                            {"name": "福州" },
                            {"name": "阜新" },
                            {"name": "阜阳" },
                            {"name": "防城港"  }
                        ]
                    }, {
                        "firstchar": "G",
                        "cities": [
                            {"name": "固原" },
                            {"name": "广元" },
                            {"name": "广安" },
                            {"name": "广州" },
                            {"name": "果洛" },
                            {"name": "桂林" },
                            {"name": "甘南" },
                            {"name": "甘孜" },
                            {"name": "贵港" },
                            {"name": "贵阳" },
                            {"name": "赣州" },
                            {"name": "高雄" },
                            {"name": "桂林"}
                        ]
                    }, {
                        "firstchar": "H",
                        "cities": [
                            {"name": "华山" },
                            {"name": "合肥" },
                            {"name": "呼伦贝尔" },
                            {"name": "呼和浩特" },
                            {"name": "和田" },
                            {"name": "哈密市" },
                            {"name": "哈尔滨" },
                            {"name": "怀化" },
                            {"name": "惠东" },
                            {"name": "惠州" },
                            {"name": "杭州" },
                            {"name": "汉中" },
                            {"name": "河池" },
                            {"name": "河源" },
                            {"name": "海东" },
                            {"name": "海北" },
                            {"name": "海口" },
                            {"name": "海林" },
                            {"name": "海西" },
                            {"name": "淮北" },
                            {"name": "淮南" },
                            {"name": "淮安" },
                            {"name": "湖州" },
                            {"name": "红河" },
                            {"name": "花莲" },
                            {"name": "菏泽" },
                            {"name": "葫芦岛" },
                            {"name": "衡水" },
                            {"name": "衡阳" },
                            {"name": "贺州" },
                            {"name": "邯郸" },
                            {"name": "香港" },
                            {"name": "鹤壁" },
                            {"name": "鹤岗" },
                            {"name": "黄冈" },
                            {"name": "黄南" },
                            {"name": "黄山" },
                            {"name": "黄果树" },
                            {"name": "黄石" },
                            {"name": "黑水" },
                            {"name": "黑河"  }
                        ]
                    }, {
                        "firstchar": "J",
                        "cities": [
                            {"name": "九华山" },
                            {"name": "九寨沟" },
                            {"name": "九江" },
                            {"name": "佳木斯" },
                            {"name": "吉安" },
                            {"name": "吉林市" },
                            {"name": "嘉义县" },
                            {"name": "嘉义市" },
                            {"name": "嘉兴" },
                            {"name": "嘉峪关" },
                            {"name": "嘉善"},
                            {"name": "基隆" },
                            {"name": "揭阳" },
                            {"name": "晋中" },
                            {"name": "晋城" },
                            {"name": "景德镇" },
                            {"name": "江口" },
                            {"name": "江门" },
                            {"name": "济南" },
                            {"name": "济宁" },
                            {"name": "济源" },
                            {"name": "焦作" },
                            {"name": "荆州" },
                            {"name": "荆门" },
                            {"name": "酒泉" },
                            {"name": "金华" },
                            {"name": "金昌" },
                            {"name": "金门" },
                            {"name": "锦州" },
                            {"name": "鸡西"  }
                        ]
                    }, {
                        "firstchar": "K",
                        "cities": [
                            {"name": "克孜勒苏" },
                            {"name": "克拉玛依" },
                            {"name": "喀什" },
                            {"name": "开封" },
                            {"name": "昆山" },
                            {"name": "昆明"  }
                        ]
                    }, {
                        "firstchar": "L",
                        "cities": [
                            {"name": "临夏" },
                            {"name": "临汾" },
                            {"name": "临沂" },
                            {"name": "临沧" },
                            {"name": "临高" },
                            {"name": "丽水" },
                            {"name": "丽江" },
                            {"name": "乐东" },
                            {"name": "乐山" },
                            {"name": "六安" },
                            {"name": "六盘水" },
                            {"name": "兰州" },
                            {"name": "凉山" },
                            {"name": "吕梁" },
                            {"name": "娄底" },
                            {"name": "庐山" },
                            {"name": "廊坊" },
                            {"name": "拉萨" },
                            {"name": "来宾" },
                            {"name": "林芝" },
                            {"name": "柳州" },
                            {"name": "泸州" },
                            {"name": "泸沽湖" },
                            {"name": "洛阳" },
                            {"name": "漯河" },
                            {"name": "理县" },
                            {"name": "聊城" },
                            {"name": "辽源" },
                            {"name": "辽阳" },
                            {"name": "连云港" },
                            {"name": "陇南" },
                            {"name": "陵水" },
                            {"name": "龙岩"  }
                        ]
                    }, {
                        "firstchar": "M",
                        "cities": [
                            {"name": "梅州" },
                            {"name": "漠河" },
                            {"name": "澳门" },
                            {"name": "牡丹江" },
                            {"name": "眉山" },
                            {"name": "绵阳" },
                            {"name": "苗栗" },
                            {"name": "茂名" },
                            {"name": "马祖" },
                            {"name": "马鞍山"  }
                        ]
                    }, {
                        "firstchar": "N",
                        "cities": [
                            {"name": "内江" },
                            {"name": "南京" },
                            {"name": "南充" },
                            {"name": "南宁" },
                            {"name": "南平" },
                            {"name": "南投" },
                            {"name": "南昌" },
                            {"name": "南通" },
                            {"name": "南阳" },
                            {"name": "南靖" },
                            {"name": "宁德" },
                            {"name": "宁波" },
                            {"name": "怒江" },
                            {"name": "那曲"  }
                        ]
                    }, {
                        "firstchar": "P",
                        "cities": [
                            {"name": "屏东" },
                            {"name": "平凉" },
                            {"name": "平顶山" },
                            {"name": "攀枝花" },
                            {"name": "普洱" },
                            {"name": "普陀山" },
                            {"name": "澎湖" },
                            {"name": "濮阳" },
                            {"name": "盘锦" },
                            {"name": "莆田" },
                            {"name": "萍乡"  }
                        ]
                    }, {
                        "firstchar": "Q",
                        "cities": [
                            {"name": "七台河" },
                            {"name": "千岛湖" },
                            {"name": "庆阳" },
                            {"name": "曲靖" },
                            {"name": "泉州" },
                            {"name": "清远" },
                            {"name": "琼中" },
                            {"name": "琼海" },
                            {"name": "秦皇岛" },
                            {"name": "衢州" },
                            {"name": "钦州" },
                            {"name": "青岛" },
                            {"name": "黔东南" },
                            {"name": "黔南" },
                            {"name": "黔西南" },
                            {"name": "齐齐哈尔"  }
                        ]
                    }, {
                        "firstchar": "R",
                        "cities": [
                            {"name": "日喀则" },
                            {"name": "日照"  }
                        ]
                    }, {
                        "firstchar": "S",
                        "cities": [
                            {"name": "三亚" },
                            {"name": "三明" },
                            {"name": "三沙" },
                            {"name": "三门峡" },
                            {"name": "上海" },
                            {"name": "上饶" },
                            {"name": "十堰" },
                            {"name": "双鸭山" },
                            {"name": "商丘" },
                            {"name": "商洛" },
                            {"name": "四平" },
                            {"name": "宿州" },
                            {"name": "宿迁" },
                            {"name": "山南" },
                            {"name": "朔州" },
                            {"name": "松原" },
                            {"name": "汕头" },
                            {"name": "汕尾" },
                            {"name": "沈阳" },
                            {"name": "深圳" },
                            {"name": "石嘴山" },
                            {"name": "石家庄" },
                            {"name": "石林" },
                            {"name": "石河子" },
                            {"name": "神农架" },
                            {"name": "绍兴" },
                            {"name": "绥化" },
                            {"name": "苏州" },
                            {"name": "遂宁" },
                            {"name": "邵阳" },
                            {"name": "随州" },
                            {"name": "韶关"  }
                        ]
                    }, {
                        "firstchar": "T",
                        "cities": [
                            {"name": "台东" },
                            {"name": "台中" },
                            {"name": "台北" },
                            {"name": "台南" },
                            {"name": "台州" },
                            {"name": "吐鲁番" },
                            {"name": "唐山" },
                            {"name": "塔城" },
                            {"name": "天水" },
                            {"name": "天津" },
                            {"name": "太原" },
                            {"name": "太湖" },
                            {"name": "屯昌" },
                            {"name": "桃园" },
                            {"name": "泰安" },
                            {"name": "泰山" },
                            {"name": "泰州" },
                            {"name": "腾冲" },
                            {"name": "通化" },
                            {"name": "通辽" },
                            {"name": "铁岭" },
                            {"name": "铜仁" },
                            {"name": "铜川" },
                            {"name": "铜陵" },
                            {"name": "桐乡"}
                        ]
                    }, {
                        "firstchar": "W",
                        "cities": [
                            {"name": "万宁" },
                            {"name": "乌兰察布" },
                            {"name": "乌海" },
                            {"name": "乌镇" },
                            {"name": "乌鲁木齐" },
                            {"name": "五家渠" },
                            {"name": "五常" },
                            {"name": "五指山" },
                            {"name": "吴忠" },
                            {"name": "威海" },
                            {"name": "文山" },
                            {"name": "文昌" },
                            {"name": "无锡" },
                            {"name": "梧州" },
                            {"name": "武夷山" },
                            {"name": "武威" },
                            {"name": "武当山" },
                            {"name": "武汉" },
                            {"name": "温州" },
                            {"name": "渭南" },
                            {"name": "潍坊" },
                            {"name": "芜湖"  }
                        ]
                    }, {
                        "firstchar": "X",
                        "cities": [
                            {"name": "仙桃" },
                            {"name": "信阳" },
                            {"name": "兴安盟" },
                            {"name": "厦门" },
                            {"name": "咸宁" },
                            {"name": "咸阳" },
                            {"name": "孝感" },
                            {"name": "宣城" },
                            {"name": "徐州" },
                            {"name": "忻州" },
                            {"name": "新乡" },
                            {"name": "新余" },
                            {"name": "新北" },
                            {"name": "新竹" },
                            {"name": "新竹县" },
                            {"name": "湘潭" },
                            {"name": "湘西" },
                            {"name": "襄阳" },
                            {"name": "西双版纳" },
                            {"name": "西塘" },
                            {"name": "西宁" },
                            {"name": "西安" },
                            {"name": "许昌" },
                            {"name": "邢台" },
                            {"name": "锡林郭勒盟" },
                            {"name": "雪乡" },
                            {"name": "香格里拉" },
                            {"name": "香港"  }
                        ]
                    }, {
                        "firstchar": "Y",
                        "cities": [
                            {"name": "云林" },
                            {"name": "云浮" },
                            {"name": "伊春" },
                            {"name": "伊犁" },
                            {"name": "宜兰" },
                            {"name": "宜宾" },
                            {"name": "宜昌" },
                            {"name": "宜春" },
                            {"name": "岳阳" },
                            {"name": "延安" },
                            {"name": "延边" },
                            {"name": "扬州" },
                            {"name": "榆林" },
                            {"name": "永州" },
                            {"name": "烟台" },
                            {"name": "玉林" },
                            {"name": "玉树" },
                            {"name": "玉溪" },
                            {"name": "益阳" },
                            {"name": "盐城" },
                            {"name": "营口" },
                            {"name": "运城" },
                            {"name": "银川" },
                            {"name": "阳朔" },
                            {"name": "阳江" },
                            {"name": "阳泉" },
                            {"name": "雅安" },
                            {"name": "鹰潭"  }
                        ]
                    }, {
                        "firstchar": "Z",
                        "cities": [
                            {"name": "中卫" },
                            {"name": "中山" },
                            {"name": "周口" },
                            {"name": "周庄" },
                            {"name": "张家口" },
                            {"name": "张家界" },
                            {"name": "张掖" },
                            {"name": "彰化" },
                            {"name": "昭通" },
                            {"name": "枣庄" },
                            {"name": "株洲" },
                            {"name": "淄博" },
                            {"name": "湛江" },
                            {"name": "漳州" },
                            {"name": "珠海" },
                            {"name": "肇庆" },
                            {"name": "自贡" },
                            {"name": "舟山" },
                            {"name": "资阳" },
                            {"name": "遵义" },
                            {"name": "郑州" },
                            {"name": "镇江" },
                            {"name": "驻马店"  }
                        ]
                    }
                ],
                cityNav: [
                    "A","B","C","D","E","F","G","H","J","K","L","M","N","P","Q","R","S","T","W","X","Y","Z"
                ],
                hotCity: [
                    {"name": "北京" },
                    {"name": "上海" },
                    {"name": "成都" },
                    {"name": "三亚" },
                    {"name": "西安" },
                    {"name": "厦门" },
                    {"name": "重庆" },
                    {"name": "杭州" },
                    {"name": "广州" },
                    {"name": "哈尔滨" },
                    {"name": "苏州" },
                    {"name": "南京" },
                    {"name": "丽江" }
                ]
            }
        },
    mounted: function () {},
    methods: {
        selectCity: function (val) {
            this.$emit('changeCity',val);
        }
    }
}
</script>

<style scoped>
@keyframes comeCity {
    from {
        left: 100%;
    }
    to {
        left: 0;
    }
}
.city-wrapper {
    background: rgb(245, 245, 245);
    padding: 0 .4rem 0 .3rem;
    top: 0;
    z-index: 300;
    animation: comeCity 0.3s linear 0s 1;
}
.city-letter-nav {
    width: .4rem;
    height: 9rem;
    top: 15%;
    right: 0;
    background: #aca8a82e;
    font-size: .2rem;
}
.city-letter-nav .letter {
    width: 100%;
}
.one-letter {
    display: block;
    padding-left: .3rem;
    height: .6rem;
    line-height: .6rem;
}
.one-city-wrapper {
    background: #fff;
    padding: 0 .3rem;
}
.city {
    height: .7rem;
    line-height: .7rem;
    border-bottom: .02rem solid rgb(221, 221, 221);
}
.hot-city-wrapper {
    background: #fff;
    padding: .3rem .1rem .1rem .3rem;
}
.hot-city {
    min-width: 1.6rem;
    width: 30%;
    height: .7rem;
    line-height: .7rem;
    border: .02rem solid rgb(221, 221, 221);
    margin: 0 .2rem .2rem 0;
}
.one-city-wrapper div:last-child{
    border: none;
}
</style>